<template>
  <Layout>
    <Loader :loading="loading" no-axios>
      <div class="row">
        <div class="col-md-12">
          <div class="d-flex align-items-center justify-content-between">
            <div class="font-size-700" style="color: #6C7589">
              {{ lodash.startCase("financial dashboard") }}
            </div>
          </div>
        </div>
        <div class="col-md-12 mt-19px">
          <b-card>
            <b-card-title>Projection Overview</b-card-title>
            <b-card-body class="p-0">
              <div class="row g-3">
                <div class="col-md-6">
                  <cash-on-hand></cash-on-hand>
                </div>
                <div class="col-md-6">
                  <potential-inbound class="h-100"></potential-inbound>
                </div>
              </div>
            </b-card-body>
          </b-card>
        </div>
        <div class="col-md-12">
          <account-receivable-trends></account-receivable-trends>
        </div>
        <div class="col-md-12">
          <customer-account-receivable-trends></customer-account-receivable-trends>
        </div>
      </div>
    </Loader>
  </Layout>
</template>

<script>
/* eslint-disable vue/no-unused-components */

import ModelShow from "../models/show";
import CashOnHand from "./cash_on_hand/show";
import Loader from "@/components/widgets/loader";
import Row from "@/components/models/show/custom-row";
import PotentialInbound from "./components/potential-inbound";
import AccountReceivableTrends from "./account_receivable_trends";
import CustomerAccountReceivableTrends from "./customer_account_receivable_trends";

export default {
  extends: ModelShow,
  page: {
    title: "Financial Dashboard"
  },
  components: {
    Loader,
    CashOnHand,
    PotentialInbound,
    AccountReceivableTrends,
    CustomerAccountReceivableTrends
  },
  props: {
    cardTitle: {
      default() {
        return this.lodash.startCase(this.$t("dashboards.singular"));
      }
    },
    resourceRoute: { default: "dashboards" },
    modelVariable: { default: "dashboard" },
    denyEdit: { type: Boolean, default: true },
    denyDelete: { type: Boolean, default: true },
    columns: {
      type: Object,
      default() {
        return {
          [this.modelVariable || "model"]: [
            {
              key: "key",
              label: this.$t("models.key"),
              component: Row
            }
          ]
        };
      }
    }
  },
  data() {
    return {
      title: this.lodash.startCase(this.$t("dashboards.plural")),
      selectedDate: "Q1 2023",
      dateRange: "2023-01-01~2023-12-31"
    };
  },
  watch: {
    // selectedDate: {
    //   immediate: true,
    //   handler: function (val) {
    //     // if val match Q1 2023, Q2 2023, Q3 2023, etc pattern
    //
    //     if(val.match(/Q[1-4] [0-9]{4}/)){
    //       this.dateRange = this.rangeOfQuarter(val);
    //     }
    //   }
    // }
  },
  mounted() {
    // this.fetchModel();
    this.loading = false;
  },
  computed: {},
  methods: {
    getModelName() {
      return this.model["order_id"];
    },
    delete() {
      return this.$axios.delete(`/dashboards/${this.$route.params.key}`);
    },
    fetchModel() {
      this.loading = true;
      return this.$axios
        .get(`/dashboards/${this.$route.params.key}`, {
          params: {}
        })
        .then(response => {
          const {
            data: { data }
          } = response;
          this.model = {
            ...data,
            ordered_at: data.ordered_at || data.estimated_harvest_date,
            purchase_items: data.purchase_items.map(function(item, index) {
              return {
                ...item,
                index: index + 1,
                $hide: data.ticketable.ticket.customer_type === "brs"
              };
            }),
            operational_cost_document: data.files.filter(file => file.name === "operational cost document")?.[0],
            invoice_documents: data.files.filter(file => file.name === "invoice document"),
            down_payment_documents: data.files.filter(file => file.name === "down payment document")
          };
          return response;
        })
        .catch(error => this.failedAlert(error))
        .finally(() => (this.loading = false));
    },
    rangeOfQuarter(val) {
      const selectedQuarter = parseInt(val.split(" ")[0].replace("Q", ""));
      const selectedYear = parseInt(val.split(" ")[1]);

      const quarterStart = this.$moment().set({ year: selectedYear, month: (selectedQuarter - 1) * 3, date: 1 });
      const quarterEnd = this.$moment(quarterStart).endOf("quarter");

      return `${quarterStart.format("YYYY-MM-DD")}~${quarterEnd.format("YYYY-MM-DD")}`;
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep {
  .preloader-component {
    background-color: #ffffff;
  }
}
.container-title {
  margin-top: 10px;
  font-family: Lato;
  font-size: 12px;
  font-weight: 800;
  line-height: 14px;
  letter-spacing: 0.05em;
  text-align: left;
  margin-bottom: 8px;
  text-transform: uppercase;
  font-family: "Lato";
  color: #6c7589;
}
.custom-group {
  margin-bottom: 30px;
}
.custom-label,
.custom-text {
  font-family: Lato;
  font-size: 14px;

  line-height: 17px;
  letter-spacing: 0em;
  text-align: left;
}
.custom-label,
.label {
  font-weight: 700;
  color: #161b4d;
  text-transform: capitalize;
  margin-bottom: 10px;
}
.custom-text,
.value {
  font-weight: 400;
  color: #6c7589;
}

.value:not(.no-colon)::before {
  content: ": ";
}
.section-title {
  background-color: #f9fafb;
  color: #161b4d;
  padding: 14px 21px;
  text-transform: uppercase;
  font-family: Lato;
  font-size: 14px;
  font-weight: 700;
  line-height: 17px;
  letter-spacing: 0.05em;
  text-align: left;
  border: 1px solid #ececf2;
}

.section-title:first-of-type {
  border-top: none;
}
.section-body {
  padding: 14px 20px;
  .section-label,
  .section-value {
    font-family: Lato;
    font-size: 14px;
    line-height: 17px;
    letter-spacing: 0em;
    text-align: left;
  }
  .section-label {
    color: #161b4d;
    font-weight: 400;
  }
  .section-value {
    color: #161b4d;
    font-weight: 700;
    text-align: right;
  }

  .section-row {
    padding: 6px 0;
  }
}

.sale-item-thead {
  color: #161b4d;
  background-color: #f9fafb;
  text-transform: uppercase;
  font-family: Lato;
  font-size: 14px;
  font-weight: 700;
  line-height: 17px;
  letter-spacing: 0.05em;
  text-align: left;
}
.sale-item-tbody {
  color: #161b4d;
  font-family: Lato;
  font-size: 14px;
  font-weight: 400;
  line-height: 17px;
  letter-spacing: 0em;
  text-align: left;
}

::v-deep .page-content {
  background: #eef3f7;
}

$badge-background-primary: rgba(198, 239, 255, 0.3);
$badge-color-primary: #0084f3;
$badge-background-warning: #fff8e7;
$badge-color-warning: #ff9d0b;

.badge-container {
  &-base {
    background: $badge-background-primary;
    .stakeholder {
      color: #161b4d;
      font-weight: 700;
      font-size: 14px;
    }
    .name {
      font-weight: 700;
      font-size: 20px;
    }
  }

  &-primary {
    @extend .badge-container-base;
    .name {
      color: $badge-color-primary;
    }
  }

  &-warning {
    @extend .badge-container-base;
    background: $badge-background-warning;
    .name {
      color: $badge-color-warning;
    }
  }
}

::v-deep {
  .overflow-hidden {
    overflow: hidden !important;
  }
  table {
    thead {
      background: #f9fafb !important;
    }
  }
}
</style>
